import { getDefaultTheme, extendTheme } from './utils';

const theme = getDefaultTheme();

export default theme;
export { extendTheme };
